import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import "./LoginPage.css";

import { setIsMobileUserAgent } from "../../redux/userview/userviewaction";
import { getStorageItem, setStorageItem } from "../../utils/storageFunction";
import { getApiCallImagePath, getZinoDomainAppData } from "../../utils/apiCallFunction";
import loginPageImg from "../../Images/login_img.svg";
import { APP_ENVIRONMENT } from "../../Constants/Constants";
import LoginWidget from "./LoginWidget";
import InstallPromptBanner from "../../Hook/InstallPromptBanner";

function LoginPage() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { authenticate, logincall, user, isMobileUserAgent } = useSelector((state) => state.userviewstore);
  const domainData = JSON.parse(localStorage.getItem("Zino_domain_app_data"));

  let environmentValue = APP_ENVIRONMENT || "local";

  useEffect(() => {
    if (authenticate && !logincall && getStorageItem("Zino_app_user")) {
      let environmentValue = APP_ENVIRONMENT || "local";
      let userGoto = user?.goto_page;
      if (userGoto && environmentValue !== "local") {
        userGoto = userGoto.split("/");
        let app_id = getStorageItem("Zino_app_id");
        if (app_id) {
          userGoto = `/${app_id}/${userGoto[userGoto.length - 1]}`;
        } else {
          userGoto = `/${userGoto[userGoto.length - 1]}`;
        }
        navigate(userGoto);
      }

      navigate("/applist");
    }

    document.title = `${getZinoDomainAppData()?.title || "Zino"} || Login`;

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authenticate, logincall]);

  return (
    <>
      {environmentValue === "local" && (
        <div className="login_page_appbar_dev_hide">
          <label className="switch-mobile-desktop">
            <input
              className="switch-mobile-desktop-input"
              type="checkbox"
              checked={isMobileUserAgent}
              onChange={(e) => {
                dispatch(setIsMobileUserAgent(e.target.checked));
                setStorageItem("Zino_Is_Mobile_User_Agent", e.target.checked);
              }}
            />
            <span className="switch-mobile-desktop-slider"></span>
            <span className="material-symbols-outlined switch-desktop-slider">laptop_windows</span>
            <span className="material-symbols-outlined switch-mobile-slider">phone_android</span>
          </label>
        </div>
      )}
      <InstallPromptBanner />

      <div
        className={isMobileUserAgent ? "mobile_login_page_outer_wrap login_page_outer_wrap" : "login_page_outer_wrap"}
      >
        <div className="login_page_img_outer">
          <img
            className="login_page_img"
            src={
              getZinoDomainAppData()?.login_image
                ? `${getApiCallImagePath()}/api/v1/public/${getZinoDomainAppData()?.login_image}`
                : loginPageImg
            }
            alt="login img"
          ></img>
        </div>
        <LoginWidget domainData={domainData} />
      </div>
    </>
  );
}
export default LoginPage;
